import { baseApi } from "./baseApi";
import type { UiPreferences } from "@/store/slices/userPreferencesSlice";

export interface UserPreferencesPayload {
  userId: string;
  tenantId: string | null;
  instanceId: string | null;
  theme: string;
  language: string;
  uiPreferences: UiPreferences;
  createdAt: string | null;
  updatedAt: string | null;
}

interface UpdateUiPreferencesResponse {
  message: string;
  preferences: UserPreferencesPayload;
}

export const preferencesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getUserPreferences: build.query<UserPreferencesPayload, void>({
      query: () => ({ url: "/user-preferences", method: "GET" }),
      providesTags: ["UserPreferences"],
    }),
    updateUiPreferences: build.mutation<UpdateUiPreferencesResponse, UiPreferences>({
      query: (uiPreferences) => ({
        url: "/user-preferences",
        method: "PUT",
        body: { uiPreferences },
      }),
      invalidatesTags: ["UserPreferences"],
    }),
  }),
});

export const { useGetUserPreferencesQuery, useUpdateUiPreferencesMutation } = preferencesApi;
